import axios, { AxiosRequestConfig } from 'axios'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const baseUrl = import.meta.env.VITE_FUSION_BRIDGE
const analyticsRequestBaseUrl = `${baseUrl}/sessions`

const instance = axios.create({
  baseURL: analyticsRequestBaseUrl,
  timeout: 3000,
})

export function postRequest<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig,
) {
  return instance.post<T>(url, data, config)
}
